module.exports = __webpack_public_path__ + "static/media/29DUNON10.899e6c5a.jpg";